import { LAYOUT, ABOUT_ME, LOCAL_STORAGE } from "../../constants/constants";

const initialState = {
  initialData: {
    skills: [
      { name: "React", value: "3.5" },
      { name: "Redux", value: "3" },
      { name: "Angular", value: "3.5" },
      { name: "JavaScript", value: "4.5" },
      { name: "HTML", value: "4.5" },
      { name: "CSS", value: "4.5" },
      { name: "SCSS", value: "4" },
      { name: "Git", value: "4" },
    ],
    aboutMe: [
      {
        name: "Abhishek Kumar",
        designation: "Front End Developer",
        description:
          "Experienced Front End Developer with a demonstrated history of working in the Computer Software industry. Strong engineering professional skilled in HTML, CSS, Javascript, JQuery, Angular 2+ and React.",
        avatarSrc: "",
        showImage: "yes",
        iconData: [
          {
            type: ABOUT_ME.ICON_DETAILS.MAIL,
            title: "abhishek.mcs.du.2014@gmail.com",
            link: "mailto:abhishek.mcs.du.2014@gmail.com",
          },
          {
            type: ABOUT_ME.ICON_DETAILS.MOBILE,
            title: "9034367484",
            link: "tel:9034367484",
          },
          {
            type: ABOUT_ME.ICON_DETAILS.LINKEDIN,
            title: "linkedin.com/in/abhishek-kumar-uidev",
            link: "https://www.linkedin.com/in/abhishek-kumar-uidev/",
          },
          {
            type: ABOUT_ME.ICON_DETAILS.GITHUB,
            title: "github.com/abshakekumar",
            link: "https://github.com/abshakekumar",
          },
          {
            type: ABOUT_ME.ICON_DETAILS.TWITTER,
            title: "abhikum144@twitter",
            link: "https://twitter.com/abhikum144",
          },
          {
            type: ABOUT_ME.ICON_DETAILS.WEBSITE,
            title: "abshakekumar.netlify.app",
            link: "https://abshakekumar.netlify.app/",
          },
        ],
      },
    ],
  },
  useGA: false,
  templateSelected: "default",
  isLoading: true,
  viewType: {
    skills: "default",
    templateTwoColumnType: false,
    language: "progress",
    backgroundType: "none",
  },
  additionalSections: {
    language: {
      title: "Language",
      isVisible: true,
      data: [
        { name: "English", value: "4" },
        { name: "Hindi", value: "4" },
      ],
    },
    awards: {
      title: "Awards",
      isVisible: false,
      data: [
        {
          title: "Sample Award Name",
          description: "Sample Award Description",
        },
      ],
    },
    certificates: {
      title: "Certificates",
      isVisible: false,
      data: [
        {
          title: "Sample Certificate Name",
          description: "Sample Certificate Description",
        },
      ],
    },
  },
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case LAYOUT.SET_INITIAL_DETAILS:
      const savedResponse = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE.SAVED_DATA_KEY)
      );
      const defaultStateFromApi = {
        ...state,
        initialData: { ...state.initialData, ...payload },
        isLoading: false,
      };
      if (savedResponse) {
        return { ...savedResponse, defaultStateFromApi: defaultStateFromApi };
      }
      return {
        ...defaultStateFromApi,
        defaultStateFromApi: defaultStateFromApi,
      };
    case LAYOUT.SET_RESUME_FROM_FILE:
      const fileResponse = JSON.parse(payload);
      const importedFileState = {
        ...state,
        ...fileResponse,
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(importedFileState)
      );
      return importedFileState;
    case LAYOUT.SET_REDUX_KEY:
      const updatedState = {
        ...state,
        initialData: {
          ...state.initialData,
          ...payload,
        },
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(updatedState)
      );
      return updatedState;
    case LAYOUT.SET_DEFAULT_STATE:
      localStorage.clear();
      return {
        ...state.defaultStateFromApi,
        defaultStateFromApi: state.defaultStateFromApi,
      };
    case LAYOUT.SET_TEMPLATE:
      const updatedStateTemplate = {
        ...state,
        templateSelected: payload,
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(updatedStateTemplate)
      );
      return updatedStateTemplate;
    case LAYOUT.SET_VIEW_TYPE:
      const viewTypeState = {
        ...state,
        viewType: {
          ...state.viewType,
          ...payload,
        },
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(viewTypeState)
      );
      return viewTypeState;
    case LAYOUT.SET_ADDITIONAL_FIELDS:
      const additionalFieldsState = {
        ...state,
        additionalSections: {
          ...state.additionalSections,
          [payload.key]: {
            ...state.additionalSections[payload.key],
            data: payload.value,
          },
        },
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(additionalFieldsState)
      );
      return additionalFieldsState;
    case LAYOUT.UPDATE_ADDITIONAL_FIELDS:
      const updatedAdditionalFieldsState = {
        ...state,
        additionalSections: {
          ...state.additionalSections,
          ...payload,
        },
      };
      localStorage.setItem(
        LOCAL_STORAGE.SAVED_DATA_KEY,
        JSON.stringify(updatedAdditionalFieldsState)
      );
      return updatedAdditionalFieldsState;
    default:
      return state;
  }
}
